window.loadGoogleMapsOnDemand = function loadGoogleMapsOnDemand() {
    $.getScript('/plugins/GoogleMaps/js/mtc_google_maps.js').done(function () {
        newDealershipMap();

        if ($('.dealershipPageWrapRedesign').length) {
            directionsMap();
        }

        map_loaded = true;
    });
}